export interface ExpectedSheetConfiguration {
  columns: ExpectedColumnConfiguration[];
}

export interface ExpectedColumnConfiguration {
  headerName: string;
  isMandatory?: boolean;
  isMandatoryErrorCode?: string;
  dataType?: ExcelSheetColumnDataType;
  dataTypeErrorCode?: string;
}

export enum ExcelSheetColumnDataType {
  String = 'String',
  Boolean = 'Boolean',
  Number = 'Number',
  Integer = 'Integer',
  Date = 'Date',
  StringList = 'StringList'
};
